// extracted by mini-css-extract-plugin
export default {"main":"AsignaturaConFiltroSelector_main__MHFv1","actions":"AsignaturaConFiltroSelector_actions__yN8Dy"};